<p-dialog
  header="Editar dados da receita"
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '720px', maxWidth: 'calc(100vw - 2rem)' }"
  (visibleChange)="onVisibleChange($event)">
  <ng-container *ngIf="invoice">
    <form class="invoice-revenue-edit" [formGroup]="form" (ngSubmit)="onSubmit()">

      <p-message
        *ngIf="!canEditPayerAndAddress"
        severity="warn"
        text="Pagador e endereço só podem ser editados em notas com status Falha, Pendente ou Cancelado.">
      </p-message>

      <p-message
        *ngIf="errorMessage"
        severity="error"
        [text]="errorMessage">
      </p-message>

      <div *ngIf="loading" class="invoice-revenue-edit__loading">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      </div>

      <div class="invoice-revenue-edit__content" [class.invoice-revenue-edit__content--busy]="loading">
        <section class="invoice-revenue-edit__section">
          <div class="invoice-revenue-edit__section-header">
            <span class="invoice-revenue-edit__section-title">Dados da receita</span>
          </div>
          <div class="invoice-revenue-edit__meta">
            <span>Receita #{{ invoice.revenueId }}</span>
            <span>Nota {{ invoice.number }}</span>
            <span appCamelCaseText>{{ invoice.serviceName }}</span>
          </div>
        </section>

        <section class="invoice-revenue-edit__section" formGroupName="customer">
          <div class="invoice-revenue-edit__section-header">
            <span class="invoice-revenue-edit__section-title">Dados do pagador</span>
          </div>
          <div class="p-fluid grid">
            <div class="field col-12 md:col-8">
              <span class="p-float-label">
                <input id="invoiceRevenueCustomerName" type="text" pInputText formControlName="name">
                <label for="invoiceRevenueCustomerName">Nome completo</label>
              </span>
              <small *ngIf="form.controls.customer.controls.name.touched && form.controls.customer.controls.name.invalid" class="p-error">
                Informe o nome do pagador.
              </small>
            </div>

            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input id="invoiceRevenueCustomerTaxId" type="text" pInputText formControlName="taxId" mask="000.000.000-00||00.000.000/0000-00">
                <label for="invoiceRevenueCustomerTaxId">CPF/CNPJ</label>
              </span>
              <small *ngIf="form.controls.customer.controls.taxId.touched && form.controls.customer.controls.taxId.invalid" class="p-error">
                Informe o documento.
              </small>
            </div>
          </div>
        </section>

        <section class="invoice-revenue-edit__section">
          <div class="invoice-revenue-edit__section-header">
            <span class="invoice-revenue-edit__section-title">Endereço da receita</span>
          </div>
          <split-address-form
            formGroupName="address"
            [showEmail]="true"
            [useRevenuePostalCodeRules]="true"
            cityStateFieldType="input">
          </split-address-form>
        </section>
      </div>

      <div class="invoice-revenue-edit__footer" aria-label="Ações da modal">
        <p-button
          type="button"
          label="Cancelar"
          styleClass="p-button-text"
          [disabled]="saving"
          (click)="onCancel()">
        </p-button>
        <p-button
          type="submit"
          label="Salvar"
          icon="pi pi-check"
          [loading]="saving"
          [disabled]="submitDisabled">
        </p-button>
      </div>
    </form>
  </ng-container>
</p-dialog>
